import { defineComponent as _defineComponent } from 'vue'
import { type PollTailwindClasses } from '@@/bits/post_color'
import type { PollResult } from '@@/types'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { computed, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostPollResult',
  props: {
    result: null,
    index: null,
    numResults: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    displayMode: { default: 'default' },
    isStream: { type: Boolean, default: false },
    pollColors: null,
    decimalPercentage: { type: Boolean, default: false },
    pollScaleMultiplier: { default: 1 }
  },
  setup(__props: any) {

const props = __props as { result: PollResult, index: number, numResults: number, darkMode: boolean | 'auto', displayMode: 'expanded' | 'default' | 'slideshow', isStream: boolean, pollColors: PollTailwindClasses, decimalPercentage: boolean, pollScaleMultiplier: number };



const {
  darkMode,
  displayMode,
  isStream,
  result,
  numResults,
  pollColors,
  decimalPercentage,
  index,
  pollScaleMultiplier,
} = toRefs(props)

const isDisplayModeExpanded = computed(() => displayMode.value === 'expanded')
const isDisplayModeSlideshow = computed(() => displayMode.value === 'slideshow')
const isDisplayModeExpandedOrSlideshow = computed(() => isDisplayModeExpanded.value || isDisplayModeSlideshow.value)

return { __sfc: true,props, darkMode, displayMode, isStream, result, numResults, pollColors, decimalPercentage, index, pollScaleMultiplier, isDisplayModeExpanded, isDisplayModeSlideshow, isDisplayModeExpandedOrSlideshow, OzDivider, OzDividerColorScheme, OzIcon }
}

})